import { z } from 'zod';

/**
 * Valide un objet contre un schéma Zod.
 *
 * Volontairement une fonction pure, sans hook : elle s'utilise à l'identique
 * dans un composant fonction et dans un composant classe. C'est indispensable
 * ici, où 24 formulaires sur 96 sont encore des composants classe et portent à
 * eux seuls un tiers des champs de l'application.
 *
 * Ne lève jamais d'exception : elle s'appuie sur safeParse.
 *
 * @param {import('zod').ZodType} schema
 * @param {object} valeurs - l'objet à valider (état du formulaire, ou charge utile)
 * @returns {{valide: boolean, donnees: object|null, erreurs: Record<string, string[]>}}
 *   donnees porte les valeurs après conversion de type (z.coerce), et vaut null
 *   si la validation échoue. erreurs est indexé par nom de champ.
 */
export const validerFormulaire = (schema, valeurs) => {
  const resultat = schema.safeParse(valeurs);

  if (resultat.success) {
    return { valide: true, donnees: resultat.data, erreurs: {} };
  }

  return {
    valide: false,
    donnees: null,
    erreurs: z.flattenError(resultat.error).fieldErrors,
  };
};

/**
 * Premier message d'erreur d'un champ, ou null s'il n'y en a pas.
 * Les messages sont des clés de traduction, à passer par checkMot à l'affichage.
 */
export const messageDuChamp = (erreurs, champ) =>
  erreurs && erreurs[champ] && erreurs[champ].length > 0 ? erreurs[champ][0] : null;
